import { useHttp } from '@/api';
import { httpApi } from '@/api/api';

/**
 * 検索受注台帳基本情報
 */
export function searchAcceptOrderBasic(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchAcceptOrderBasic,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 受注一覧：検索条件リストの初期化(状態)
 */
export function initAcceptOrderSearchList(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.InitAcceptOrderSearchList, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 受注明細：基本情報のリスト取得（得意先担当者、担当者、状態）
 */
export function getInitInfoList(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetAcceptOrderDetailInitInfoList, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 受注明細：受注No.による受注詳細情報の取得
 */
export function searchAcceptOrderDetailByAcceptOrderNo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchAcceptOrderDetailByAcceptOrderNo,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 受注明細：受注基本と詳細情報の新規作成
 */
export function addAcceptOrderDetail(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.AddAcceptOrderDetail,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 受注明細：再度受注処理
 */
export function addReacceptOrderDetail(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.AddReacceptOrderDetail,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 受注明細：受注No.による受注詳細情報の更新
 */
export function updateAcceptOrderDetail(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.UpdateAcceptOrderDetail,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 加工詳細：受注情報から注文情報の取得
 */
export function searchOrderInfoFromAcceptInfo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchOrderInfoFromAcceptInfo,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 基本情報のリスト取得（得意先担当者、担当者、状態）
 */
export function getCommonInfoList(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetCommonInfoList, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 得意先会社リストの取得
 */
export function getCustomersList() {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetCustomersList)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 受注可能採番一覧の取得
 */
export function getAcceptableNumber(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetAcceptableNumber, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 採番情報から受注可能製品の取得
 */
export function getAcceptProductFromNumber(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetAcceptProductFromNumber, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 採番情報から受注した詳細製品情報の取得
 */
export function getAcceptDetailInfoFromNumber(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetAcceptedDetailInfoFromNumber, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 受注情報の削除
 */
export function deleteAcceptInfoByQuoteNo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.DeleteAcceptInfoByQuoteNo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 納品異常情報の検索
 */
export function searchProductExInfoByAobQuoteNo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchProductExInfoByAobQuoteNo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


// ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
// 納期、注番の変更(見積単位⇒製品単位に変更)
/**
 * 納品異常情報の保存
 */
export function saveProductExInfoByAobQuoteNo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SaveProductExInfoByAobQuoteNo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

/**
 * 通常製品情報の検索
 */
export function searchProductNormalInfoByAobQuoteNo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchProductNormalInfoByAobQuoteNo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 製品クローズ選択の更新
 */
export function updateProductCloseSelectData(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.UpdateProductCloseSelectData, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
// 課題_納期分割機能の追加
/**
 * 製品分割、製品補足、製品クローズ画面：データ検索
*/
export function searchAodProdInfoByProdNo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchAodProdInfoByProdNo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 製品分割、製品補足、製品クローズ画面：データ保存
*/
export function updAodProdInfo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
    .request(httpApi.UpdAodProdInfo, data)
    .then(res => {
      resolve(res)
    })
    .catch(err => {
      reject(err)
    })
  })
  // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
}

